export default "__VITE_ASSET__D$DKTQ2A__"